type Role = {
  dates: string;
  location: string;
  title: string;
  company: string;
  points: string[];
  current?: boolean;
};

const roles: Role[] = [
  {
    dates: 'October 2022 to October 2025',
    location: 'Arlington, VA',
    title: 'Software Development Engineer',
    company: 'Amazon Prime Video',
    current: true,
    points: [
      'Owned end to end delivery of internal automation, reliability, and tooling across nine Live and VOD products.',
      'Architected event driven pipelines on AWS Lambda, SQS, SNS, and DynamoDB that processed operational signals at scale, cutting time to task initiation by 95 percent.',
      'Built a triage and routing platform that improved routing accuracy by 89 percent.',
      'Designed observability dashboards giving engineering and operations teams real time visibility into system health.',
      'Maintained over 99.9 percent uptime across nine concurrent products through on call rotations and proactive monitoring.',
    ],
  },
  {
    dates: 'January 2022 to October 2022',
    location: 'Arlington, VA',
    title: 'SDE Training Program',
    company: 'Amazon Technical Academy',
    points: [
      'Full time software engineering program covering Java, data structures, algorithms, and AWS systems, culminating in a full stack team capstone.',
    ],
  },
  {
    dates: 'July 2020 to December 2021',
    location: 'Baltimore, MD',
    title: 'Technical Support Associate',
    company: 'Amazon Fulfillment',
    points: [
      'Forecasted hardware shortages ahead of peak seasons and pre stocked equipment, preventing a projected 30 percent capacity loss and keeping operations running.',
      'Identified user pain points and designed a streamlined provisioning workflow for PCs and thin clients, reducing setup time by 15 percent and speeding up new hire onboarding.',
    ],
  },
];

const RoleContent = ({ role }: { role: Role }) => (
  <div className="exp-content">
    <div className="exp-date">
      {role.dates} · {role.location}
    </div>
    <h3 className="exp-role">{role.title}</h3>
    <p className="exp-company">{role.company}</p>
    <ul className="exp-list">
      {role.points.map((point) => (
        <li key={point}>{point}</li>
      ))}
    </ul>
  </div>
);

export const Experience = () => {
  return (
    <section id="experience" className="section">
      <div className="section-head reveal">
        <div>
          <p className="section-eyebrow">03 — Experience</p>
          <h2 className="section-title">Where I've worked.</h2>
        </div>
      </div>
      <ol className="exp-timeline">
        {roles.map((role, i) => {
          const onLeft = i % 2 === 0;
          return (
            <li className="exp-row reveal" key={role.title + role.company}>
              <div className="exp-side exp-side-left">
                {onLeft && <RoleContent role={role} />}
              </div>
              <div className="exp-spine">
                <span className="exp-spine-fill" />
                <span
                  className={role.current ? 'exp-dot exp-dot-accent' : 'exp-dot'}
                />
              </div>
              <div className="exp-side exp-side-right">
                {!onLeft && <RoleContent role={role} />}
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
